import gql from 'graphql-tag';

export const CHANGE_PREFERRED_LOCATION_MUTATION = gql`
  mutation MyChangePreferredLocation($input: ChangePreferredLocation!) {
    changePreferredLocation(input: $input) {
      user {
        userId
        preferredLocation
        roles
      }
    }
  }
`;
